// extracted by mini-css-extract-plugin
module.exports = {"threeColumn":"three-column-module--threeColumn--3rOFY"};